import axios from 'axios'

export const GET_SINGLE_POST_WITH_OWNER = async (postID) => {
  const getSignlePostWithOwner = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/products/getSignleProductWithOwner/${postID}`
  )
  return getSignlePostWithOwner
}
